module.exports = __webpack_public_path__ + "832e7b5c94bcc9f288bfc05c4688f88a.svg";